// Pure builder for the organization Gmail OAuth authorization request. Extracted from the manage
// screen so the parameter mapping is unit-testable and the electron/browser fork in the component
// stays thin (electron consumes `authUrl`; the browser branch posts `params` to `endpoint`).

export const GMAIL_OAUTH_ENDPOINT =
  "https://accounts.google.com/o/oauth2/v2/auth";

// Google only allows redirect_uri values that are pre-registered (in Google Cloud Console) for the
// OAuth client. The organization flow reuses the personal flow's already-registered `/callback/gmail`
// redirect_uri rather than requiring a second Console registration for `/callback/gmail-org` — this
// state value is how the shared callback route (GmailAuthRetrun.tsx) tells the two flows apart.
export const ORG_GMAIL_OAUTH_STATE = "org-email";

export interface GmailOAuthRedirectInput {
  clientId: string;
  redirectUri: string;
  scopes: string;
  state?: string;
}

export interface GmailOAuthRedirect {
  endpoint: string;
  params: Record<string, string>;
  authUrl: string;
}

export const buildGmailOAuthRedirect = ({
  clientId,
  redirectUri,
  scopes,
  state = "pass-through value",
}: GmailOAuthRedirectInput): GmailOAuthRedirect => {
  const params: Record<string, string> = {
    client_id: `${clientId}`,
    redirect_uri: redirectUri,
    response_type: "code",
    scope: scopes,
    include_granted_scopes: "false",
    state,
    access_type: "offline",
    prompt: "consent",
  };

  const authUrl = `${GMAIL_OAUTH_ENDPOINT}?${new URLSearchParams(params).toString()}`;

  return { endpoint: GMAIL_OAUTH_ENDPOINT, params, authUrl };
};
